import React from 'react';
import FlipMove from 'react-flip-move';
import RecruitmentItem from './RecruitItem';

const ApplicationList = (props) => (
    <div>
        <FlipMove
            staggerDelayBy={50}
            appearAnimation="fade"
            enterAnimation="fade"
            leaveAnimation="fade"
        >
        {props.recruits.map((recruit) => (
            <RecruitmentItem users={props.users} ranks={props.ranks} recruit={recruit} auth={props.auth} />
        ))}
        </FlipMove>
        {props.recruits.length === 0 ? (
            <div className="panel-adt">
                No Recruits
            </div>
        ) : ('')}
    </div>
);

export default ApplicationList;


// WEBPACK FOOTER //
// ./src/Recruitment/RecruitList.js